import { render, staticRenderFns } from "./CarBasicInfoData.vue?vue&type=template&id=2358885c"
import script from "./CarBasicInfoData.vue?vue&type=script&lang=js"
export * from "./CarBasicInfoData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports